module.exports = __webpack_public_path__ + "media/images/rent_icon_active-6982f4f5.svg";